export const UPLOAD_TYPE = 'FileUpload';
export const DOWNLOAD_TYPE = 'FileDownload';
export const CHANGE_TYPE = 'TailSpendUpdate';
export const UPLOAD_STATUS = {
	NO_DATA: 1,
	UPLOADED: 2,
	VALIDATED: 4,
	CLASSIFYING: 6,
	CLASSIFIED: 8,
	PUBLISHED: 16,
	FAILED: 32,
};

export const DIRECT_TAXONOMY_STATUS = {
	NOT_STARTED: 1,
	IN_PROGRESS: 2,
	COMPLETED: 4,
	FAILED: 8,
};

export const FILE_TYPES = {
	TRANSACTIONS: 2,
	UNCLASSIFIED_INDIRECT: 4,
	UNCLASSIFIED_DIRECT: 5,
};

export const SPEND_TYPE = {
	DIRECT: 'direct',
	INDIRECT: 'indirect',
};

export const SPEND_PARAM = {
	DIRECT: 0,
	INDIRECT: 1,
};

export const VENDOR_UPLOAD_STATUS = {
	UNEXCEPTED_ERROR: 0,
	NO_DATA: 1,
	UPLOADING: 2,
	UPLOADFAILED: 3,
	UPLOADED: 4,
	VALIDTING: 5,
	VALIDATIONFAILED: 6,
	VALIDATED: 7,
	FILEFORMATERROR: 8,
	ILLEGALCHARACTERERROR: 9,
	TRANSLATING: 10,
	TRANSLATIONFAILED: 11,
	TRANSLATED: 12,
	PREPROCESSINGFAILED: 13,
	DEDUPPING: 14,
	DEDUPFAILED: 15,
	DEDUPPED: 16,
	FILEGENERATED: 17,
	FILEGENERATIONFAILED: 18,
	PUBLISHING: 19,
	PUBLISHFAILED: 20,
	PUBLISHED: 21,
};

export const CATEGORY_UPLOAD_STATUS = {
	NO_DATA: 1,
	UPLOADING: 2,
	UPLOADED: 3,
	VALIDTING: 4,
	VALIDATED: 5,
	PIPELINESTARTING: 6,
	DATACOPY: 7,
	DATATRANSFORMATION: 8,
	DATATRANSFORMED: 9,
	DATAPUBLISHED: 10,
	ERRORSTATE: 99,
	CATEGORYDATAUPLOADFAILED: 90,
	CATEGORYDATAVALIDATIONFAILED: 91,
};

export const SKU_UPLOAD_STATUS = {
	NO_DATA: 1,
	UPLOADING: 2,
	UPLOADED: 3,
	VALIDTING: 4,
	VALIDATED: 5,
	PIPELINESTARTING: 6,
	DATACOPY: 7,
	DATAPUBLISHED: 8,
	SKUDATAUPLOADFAILED: 90,
	ERRORSTATE: 99,
	SKUDATAVALIDATIONFAILED: 91,
};
